<template>
  <div class="time_trading">
    <div class="type_title">
      {{ this.$t('盘口') }}
    </div>
    <div class="type_content">
      <!-- 盘口 -->
      <div class="handicap">
        <div class="handicap_head">
          <div
            class="icon_box"
            v-for="item in handicapList"
            :key="item.name"
            @click="$store.commit('contract/SET_CURRENT_HANDICAP', item.name)"
          >
            <img
              v-if="shimHandicap === item.name"
              :src="item.imageAtive"
              alt=""
              class="full_img"
            />
            <img v-else :src="item.imageNagetive" alt="" class="full_img" />
          </div>
        </div>
        <div class="handicap_body">
          <dl>
            <dt class="dt_title">
              <span>{{ $t('价格') }}</span>
              <span>{{ $t('数量') }}</span>
            </dt>
            <dd class="dd_description">
              <div
                :style="{
                  top:
                    { buySell: -396, buy: -758, sell: -45 }[shimHandicap] +
                    'px',
                }"
                class="description_content"
              >
                <ul class="sell_ul">
                  <li
                    class="sell_li jump"
                    v-for="(item, index) in sellHandicap"
                    :key="index"
                    @click="handlePrice(item.price)"
                  >
                    <span>{{ item.price | initFilter('---') }}</span>
                    <span>{{ item.quantity | initFilter('---') }}</span>
                  </li>
                </ul>
                <div class="coin_price">
                  <span
                    :class="{
                      current_up: Number(contractData.change) > 0,
                      current_down: Number(contractData.change) < 0,
                    }"
                    class="price"
                  >
                    {{ currentPrice }}
                  </span>
                  <!-- <span class="more" @click="jumpTo('/buyingSelling')">{{
                    $t('更多')
                  }}</span> -->
                </div>
                <ul class="buy_ul">
                  <li
                    class="buy_li jump"
                    v-for="(item, index) in buyHandicap"
                    :key="index"
                    @click="handlePrice(item.price)"
                  >
                    <span>{{ item.price | initFilter('---') }}</span>
                    <span>{{ item.quantity | initFilter('---') }}</span>
                  </li>
                </ul>
              </div>
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { sendWSPush, createSocket } from '@/utils/contractWebSocket'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      handicapList: [
        {
          name: 'buySell',
          imageNagetive: require('@/assets/images/panko-quanbu-weixuan.png'),
          imageAtive: require('@/assets/images/panko-quanbu-yixuan.png'),
        },
        {
          name: 'buy',
          imageNagetive: require('@/assets/images/panko-lvse-weixuanzhe.png'),
          imageAtive: require('@/assets/images/panko-lvse-yixuan.png'),
        },
        {
          name: 'sell',
          imageNagetive: require('@/assets/images/panko-hongse-weixuanzhe.png'),
          imageAtive: require('@/assets/images/panko-hongse-yixuan.png'),
        },
      ],
      sellHandicap: 25, // 盘口卖盘数据
      buyHandicap: 25, // 盘口买盘数据
    }
  },
  computed: {
    ...mapState('contract', [
      'shimHandicap',
      'contractData',
      'plateData',
      'handicapFirstPrice',
      'buySellTop',
    ]),
    contractNo() {
      return this.contractData.contractNo
    },
    currentPrice() {
      return this.contractData.price || '---'
    },
  },
  watch: {
    contractNo: {
      handler(newVal) {
        // 盘口数据loading
        this.sellHandicap = 25 // 盘口卖盘数据
        this.buyHandicap = 25 // 盘口买盘数据

        // 将交易操作栏输入框中的值清空
        this.$store.commit('contract/SET_HANDICAP_FIRST_PRICE', {
          unassigned: true,
          buyFirstPrice: '',
          sellFirstPrice: '',
        })

        createSocket(process.env.VUE_APP_CONTRACT_WS)

        // eslint-disable-next-line
        sendWSPush({ channel: newVal.toLowerCase(), language: 'zh' })
      },
      immediate: true,
    },
    plateData(newVal) {
      if (this.contractNo === newVal.contractNo) {
        const sellData = newVal.asks.reverse()
        const buyData = newVal.bids
        this.assembleHandicap(sellData)
        this.assembleHandicap(buyData)
        this.sellHandicap = sellData
        this.buyHandicap = buyData

        if (this.handicapFirstPrice.unassigned) {
          this.$store.commit('contract/SET_HANDICAP_FIRST_PRICE', {
            unassigned: false,
            buyFirstPrice: `${this.buyHandicap[0].price}`,
            sellFirstPrice: `${this.sellHandicap[0].price}`,
          })
        }
      }
    },
  },
  methods: {
    handlePrice(price) {
      if (price) {
        const priceObj = {
          buyFirstPrice: `${price}`,
          sellFirstPrice: `${price}`,
        }
        this.$store.commit('contract/SET_HANDICAP_FIRST_PRICE', priceObj)
      }
    },
    // 组装盘口数据
    assembleHandicap(array) {
      if (array.length < 25) {
        const targetLength = 25 - array.length
        for (let i = 0; i < targetLength; i++) {
          array.push(['---', '---', '---'])
        }
      } else {
        const deleteLength = array.length - 25
        array.splice(25, deleteLength)
      }
    },
  },
}
</script>
<style lang="less" scoped>
.time_trading {
  height: 100%;
  width: 250px;
  .type_title {
    padding: 11px 24px;
    line-height: 20px;
    font-size: 16px;
    font-weight: 500;
    color: @textColor4;
    background: @titleBgColor1;
  }
  .type_content {
    // 布局要点
    height: calc(100% - 42px);
    display: flex;
    .handicap {
      width: 100%;
      background: @contentBgColor1;
    }
    .handicap {
      .handicap_head {
        padding: 8px 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .icon_box {
          margin-right: 4px;
          width: 20px;
          height: 20px;
          cursor: pointer;
        }
        .icon_box:nth-child(3) {
          margin-right: 8px;
        }
      }
      .handicap_body {
        height: calc(100% - 36px);
        dl {
          height: 100%;
          position: relative;
          .dt_title {
            padding: 7px 20px 6px 20px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            position: relative;
            span {
              font-size: 12px;
              font-weight: 400;
              color: @textColor2;
              line-height: 17px;
            }
          }
          .dd_description {
            height: calc(100% - 30px);
            overflow: hidden;
            position: relative;
            .description_content {
              position: absolute;
              width: 100%;
              top: -210px;
              .sell_ul {
                display: flex;
                flex-direction: column-reverse;
                .sell_li {
                  position: relative;
                  padding: 5px 20px;
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  align-items: center;
                  background-image: linear-gradient(
                    rgba(250, 82, 82, 0.1),
                    rgba(250, 82, 82, 0.1)
                  );
                  background-size: 0% 100%;
                  background-position: 100% 100%;
                  background-repeat: no-repeat;
                  span {
                    font-size: 14px;
                    font-weight: 400;
                    color: @textColor3;
                    line-height: 20px;
                  }
                  span:first-child {
                    color: rgba(255, 63, 74, 1);
                  }
                  &:hover {
                    background-color: @hoverBgColorOpacity;
                  }
                }
              }
              .coin_price {
                padding: 8px 20px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                .price {
                  font-size: 22px;
                  font-weight: 400;
                  color: @textColor4;
                  line-height: 30px;
                }
                .more {
                  font-size: 14px;
                  font-weight: 400;
                  color: rgba(66, 179, 250, 1);
                  line-height: 20px;
                  cursor: pointer;
                }
                // 动态控制字体颜色
                .current_up {
                  color: #3baf7c;
                }
                .current_down {
                  color: #ff3f4a;
                }
              }
              .buy_ul {
                .buy_li {
                  position: relative;
                  padding: 5px 20px;
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  align-items: center;
                  background-image: linear-gradient(
                    rgba(18, 184, 134, 0.1),
                    rgba(18, 184, 134, 0.1)
                  );
                  background-size: 0% 100%;
                  background-position: 100% 100%;
                  background-repeat: no-repeat;
                  span {
                    font-size: 14px;
                    font-weight: 400;
                    color: @textColor3;
                    line-height: 20px;
                  }
                  span:first-child {
                    color: rgba(42, 184, 134, 1);
                  }
                  &:hover {
                    background-color: @hoverBgColorOpacity;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
